import { createAction, createAsyncAction } from 'typesafe-actions';
import { JsonDressageProtocol } from './types';

export const fetchDressageProtocol = createAsyncAction(
  'dressageProtocol/FETCH_REQUEST',
  'dressageProtocol/FETCH_SUCCESS',
  'dressageProtocol/FETCH_FAILURE'
)<void, JsonDressageProtocol, Error>();

export const updateDressageProtocol = createAction('dressageProtocol/UPDATE_DRESSAGE_PROTOCOL', resolve =>
  (protocolId: string) => resolve(protocolId)
);
